class i extends Error {
  constructor(e) {
    super(e.detail), this.errors = e, this.violationsTitleToMessage();
  }
  // TODO: delete this method after BE decide what to use title or message
  violationsTitleToMessage() {
    var e;
    (e = this.errors.violations) == null || e.forEach((s) => {
      "title" in s && (s.message = s.title, delete s.title);
    });
  }
  getJoinedViolationMessages() {
    var e;
    return (e = this.errors.violations) == null ? void 0 : e.map((s) => s.message).join(", ");
  }
}
export {
  i as ErrorWithViolations
};
